import NotFound from "../../../components/notfound/NotFound";
import {Card, CardContent, Skeleton, Typography} from "@mui/material";
import {COLORS} from "../../../ui/Theme";
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {CustomTooltip} from "./historyCustomTooltip";
import {Box} from "@mui/system";

const HistoryPriceChart = ({data}) => {

    return (
        <Card
            sx={{
                border: "1px solid",
                borderColor: COLORS.SOFTGRAY,
                padding: 0,
                minHeight: 500,
            }}
        >
            <CardContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    alignItems: "center",
                }}
            >
                <Typography
                    sx={{
                        fontSize: "20px",
                        fontWeight: 700,
                        color: COLORS.BLACK,
                        textAlign: "center",
                        padding: "20px"
                    }}>
                    تاریخچه قیمت‌های نماد
                </Typography>
                {
                    !data?.data?.length ? (
                        <Box>
                            <NotFound/>
                        </Box>
                    ) : (
                        data?.isLoading ? (
                            <Skeleton
                                sx={{
                                    borderRadius: "12px"
                                }}
                                variant="rounded"
                                width="100%"
                                height="500px"
                            />
                        ) : (
                            <>
                                <ResponsiveContainer width="100%" height={500}>
                                    <LineChart
                                        data={data?.data}
                                        syncId="history"
                                        margin={{top: 0, right: 0, bottom: 20, left: 0}}
                                    >
                                        <CartesianGrid strokeDasharray="0 0" stroke={COLORS.SOFTGRAY}/>
                                        <XAxis
                                            dataKey="date"
                                            stroke={COLORS.GRAY}
                                            tickMargin={10}
                                            angle={-10}
                                        />
                                        <YAxis
                                            textAnchor="start"
                                            tickMargin={10}
                                            stroke={COLORS.GRAY}
                                            domain={["auto", "auto"]}
                                        />
                                        <Tooltip
                                        cursor={{ fill: COLORS.SOFTGRAY }}
                                            content={<CustomTooltip
                                                keysToShow={["strike", "premium_strike", "equit_close_price"]}/>}/>
                                        <Legend
                                            verticalAlign="top"
                                            wrapperStyle={{
                                                width: "fit-content",
                                                top: -10,
                                                right: 0,
                                                lineHeight: "20px",
                                            }}
                                            formatter={(value) => {
                                                if (value === "premium_strike") {
                                                    return <span style={{marginRight: "5px"}}>پرمیوم + قیمت اعمال</span>;
                                                } else if (value === "strike") {
                                                    return <span style={{marginRight: "5px"}}>قیمت اعمال</span>;
                                                } else if (value === "equit_close_price") {
                                                    return <span style={{marginRight: "5px"}}>قیمت پایانی سهم</span>;
                                                }
                                                return value;
                                            }}
                                        />
                                        <Line
                                            dataKey="strike"
                                            connectNulls
                                            type="monotone"
                                            stroke={COLORS.ORANGE}
                                            strokeWidth={2}
                                            dot={false}
                                        />
                                        <Line
                                            dataKey="premium_strike"
                                            connectNulls
                                            type="monotone"
                                            stroke={COLORS.BLUE}
                                            strokeWidth={2}
                                            dot={false}
                                        />
                                        <Line
                                            dataKey="equit_close_price"
                                            connectNulls
                                            type="monotone"
                                            stroke={COLORS.RED}
                                            strokeWidth={2}
                                            dot={false}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </>
                        )
                    )
                }
            </CardContent>
        </Card>
    );
};

export default HistoryPriceChart;